import { colors } from "../../../../data/colors";
import { docIdCodes } from "../../../../data/docCodes";
import {
  occasionalCustomerField,
  occasionalResField,
} from "../../../../data/main";
import { stdObject } from "../../../../data/types/stdObject";
import { callDocInfo } from "../../../../services/callDocInfo";
import { sendData } from "../../../../services/sendData";
import { updateRowData } from "../../../../store/updateData";
import { arrayToObject } from "../../../../utils/arrayToObject";
import { arrangeDocData } from "../arrangeDocData";
import { createCommision } from "../commissions/createCommision";
import { getPriceOrOffer } from "../getPriceOrOffer";

export const directCreateService = async (
  close: boolean = false,
  params: stdObject,
) => {
  const {
    t,
    user,
    staffList,
    items,
    dispatch,
    setDocValues,
    setDocModal,
    setWindowValues,
    packArrangeDoc,
    writeDataParams,
    windowValues,
    setMsg,
    setModalData,
    closeMsg,
    logoutAction,
  } = params;
  closeMsg();
  setModalData({});
  setMsg("loading");
  const ratePrice =
    typeof windowValues.customer?.TARCLI === "number" &&
    windowValues.customer?.TARCLI > 0
      ? windowValues.customer.TARCLI
      : 1;

  const initData = {
    PRE: getPriceOrOffer({
      data: items[windowValues.INT],
      price:
        items[windowValues.INT]?.PREART[user.CODPAI][ratePrice]?.PRELTA ?? 0,
      country: user.CODPAI,
      rate: ratePrice,
    }),
    PIM: items[windowValues.INT]?.TAX[user.CODPAI] ?? 0,
    PCO: items[windowValues.INT]?.PREPCO[user.CODPAI] ?? 0,
    ...[...occasionalCustomerField, ...occasionalResField].reduce(
      (acc: stdObject, curr: string) => {
        if (windowValues[curr]?.length > 0) {
          acc[curr] = windowValues[curr];
        }
        return acc;
      },
      {},
    ),
  };
  const payloadDocBase = {
    user,
    type: "SEV",
    serie: user.CODSUC,
    code: 0,
    person: windowValues.customer?.CODCLI,
    issues: windowValues.issues,
    mainColor: colors.services,
    initial: {
      SER: user.CODSUC,
      FEC2: windowValues.FEC2,
      INT: windowValues.INT ?? "",
      INTN: windowValues.INTN ?? "",
      ...["CLI", "NOM", "TEL", "CEL", "EMA1", "DOM"].reduce(
        (acc: stdObject, key: string) => {
          let value =
            key === "CLI"
              ? (windowValues.customer?.CODCLI ?? "")
              : key === "DOM"
                ? (windowValues.customer?.DOMCLI[0]?.DOMDIR ?? "")
                : (windowValues.customer?.[`${key}CLI`] ?? "");
          acc[key === "EMA1" ? "EMA" : key] = value;
          return acc;
        },
        {},
      ),
      ...initData,
      NET: initData.PRE,
      IMP: initData.PRE * (initData.PIM / 100),
      TOT: initData.PRE + initData.PRE * (initData.PIM / 100),
      SAL: initData.PRE + initData.PRE * (initData.PIM / 100),
      ALM: user.CODSUC,
      AGE: windowValues.AGE,
      ANO: windowValues.AGE > 0 ? windowValues.ANO : "",
      CRE: user.CODUSU,
      CNO: user.NOMUSU,
      REC: user.CODUSU,
      RNO: user.NOMUSU,
      RES: windowValues.RES ?? "",
      NRS: windowValues.NRS ?? "",
    },
    logoutAction,
  };
  const responseDocBase: stdObject = await callDocInfo(payloadDocBase);
  if (responseDocBase.id) {
    const comm =
      windowValues.AGE > 0 && windowValues.INT.length > 0
        ? createCommision({
            id: windowValues.AGE,
            name: windowValues.ANO ?? "",
            group: 0,
            itemCode: windowValues.INT,
            item: windowValues.INT in items ? items[windowValues.INT] : false,
            data: {
              LINSE0: 0,
              CANSE0: 1,
              ARTSE0: windowValues.INT,
              NOMSE0: windowValues.INTN ?? "",
              PRESE0: initData.PRE,
            },
            docValues: {
              type: "SEV",
              itemType: "SE0",
              data: {
                SERSEV: { value: user.CODSUC },
                CODSEV: { value: 0 },
              },
            },
          })
        : false;
    responseDocBase.commissions = comm ? [comm] : [];
    const newStaff = staffList.filter((e: stdObject) => e.DOCIA1 === "SEV");
    console.log("responseDocBase", responseDocBase);
    if (close) {
      responseDocBase.staff = arrayToObject({
        key: "code",
        erase: ["code"],
        data: newStaff.map((e: stdObject) => {
          return {
            code: e.CODIA1,
            id: e.CODIA1 === 0 && windowValues.AGE > 0 ? windowValues.AGE : "",
            name:
              e.CODIA1 === 0 && windowValues.AGE > 0 ? windowValues.ANO : "",
          };
        }),
      });

      const responseDirectSaveDoc: stdObject = await sendData({
        endPoint: "saveDocument",
        payload: responseDocBase,
        logoutAction,
      });

      if (responseDirectSaveDoc.success && responseDirectSaveDoc.status) {
        dispatch(
          updateRowData({
            type: responseDirectSaveDoc.type,
            data: [responseDirectSaveDoc.data],
          }),
        );
      } else {
        setMsg("error");
      }
    } else {
      responseDocBase.staff =
        windowValues.AGE > 0
          ? [
              {
                AGEIA2: windowValues.AGE,
                CODIA2: 0,
                DOCIA2: "SEV",
                NOMIA2: windowValues.ANO,
                NUMIA2: 0,
                SERIA2: user.CODSUC,
              },
            ]
          : [];

      const resultInfo = arrangeDocData(
        responseDocBase,
        packArrangeDoc,
        writeDataParams,
      );
      setDocValues({
        ...resultInfo,
        typeText: "service",
        sectionId: docIdCodes["SEV"],
        title: t("p.newSEV"),
      });
      setDocModal("document");
    }
    closeMsg();
    setWindowValues({});
  } else {
    setMsg("error");
  }
};
